module["exports"] = [
  "#{Name.name}",
  "#{Company.name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/app/author.js
// module id = 859
// module chunks = 1